import styled from 'react-emotion';
import theme from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  text-align: center;
`;

export const Title = styled('p')`
  font-family: inherit;
  font-size: ${theme.font.size.large};
  font-weight: ${theme.font.weight.medium};
  color: ${theme.color.black};
  line-height: 24px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const SubTitle = styled(Title)`
  color: ${theme.color.grey11};
`;

export const Image = styled('img')`
  margin-top: ${theme.spacing.medium};
`;
